import { useEffect } from 'react';

const resetElementLayout = (el: HTMLElement | null): void => {
  if (!el) return;

  el.classList.remove(
    'ion-page-invisible',
    'ion-page-hidden',
    'menu-content-open',
  );
  el.removeAttribute('aria-hidden');
  el.style.removeProperty('transform');
  el.style.removeProperty('opacity');
  el.style.removeProperty('z-index');
  el.style.removeProperty('left');
  el.style.removeProperty('right');
};

/** Clear stale Ionic page/menu transforms after closing a canvas. */
export const restoreHomePageLayout = (): void => {
  const homePage = document.getElementById('home');
  const main = document.getElementById('main');

  resetElementLayout(homePage);
  resetElementLayout(main);

  main?.querySelectorAll('.ion-page').forEach((page) => {
    resetElementLayout(page as HTMLElement);
  });

  window.dispatchEvent(new Event('resize'));
};

/**
 * Ionic page transitions can leave the dashboard shifted under the menu after
 * a canvas closes. Reset the homepage shell when returning to Home.
 */
export const useRestoreHomePageLayout = (canvasOpen: boolean): void => {
  useEffect(() => {
    if (canvasOpen) return undefined;

    const run = () => restoreHomePageLayout();
    run();

    const frame = requestAnimationFrame(() => {
      requestAnimationFrame(run);
    });

    return () => cancelAnimationFrame(frame);
  }, [canvasOpen]);
};

export default useRestoreHomePageLayout;
